import React from 'react';
import PropTypes from 'prop-types';
import style from '../Debug.module.scss';

const AdPanel = (props = {}) => {
  const { currentAdDebug, currentSiteSection, handleSetAd, handleSetAdSiteSection } = props;

  return (
    <div className={style.panel}>
      <div className={style.header}>Ad Debug</div>
      <div className={style.body}>
        <form onSubmit={handleSetAd}>
          <div className={style.formLabel}>ad._debug={currentAdDebug}</div>
          <div>
            <input type="text" defaultValue={currentAdDebug} name="debugValue" id="debugValue" />{' '}
            <button type="submit">Set Param</button>
          </div>
        </form>
      </div>
      <div className={style.header}>Ad Site Section</div>
      <div className={style.body}>
        <form onSubmit={handleSetAdSiteSection}>
          <div className={style.formLabel}>ad.sitesection={currentSiteSection}</div>
          <div>
            <input
              type="text"
              defaultValue={currentSiteSection}
              name="siteSectionValue"
              id="siteSectionValue"
            />{' '}
            <button type="submit">Set Param</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdPanel;

AdPanel.defaultProps = {
  currentAdDebug: '',
  currentSiteSection: '',
  handleSetAd: () => {},
  handleSetAdSiteSection: () => {},
};

AdPanel.propTypes = {
  currentAdDebug: PropTypes.string,
  currentSiteSection: PropTypes.string,
  handleSetAd: PropTypes.func,
  handleSetAdSiteSection: PropTypes.func,
};
